import { render } from "./vue3-animate-number.vue?vue&type=template&id=58b8b39c"
import script from "./vue3-animate-number.vue?vue&type=script&lang=ts"
export * from "./vue3-animate-number.vue?vue&type=script&lang=ts"

import "./vue3-animate-number.vue?vue&type=style&index=0&id=58b8b39c&lang=css"
script.render = render

export default script